import React from 'react';
import person1 from '../Assets/Person1.jpg';
import person2 from '../Assets/Person2.jpg';
import person3 from '../Assets/Person3.jpg';

const Team = () => {
  const myTeam = [
    {
      id: 1,
      name: 'Hopeton Smalling',
      title: 'Co-Founder & Leadership',
      description: 'Hopeton Smalling is a New York-based author, humanitarian, entrepreneur, tech strategist, and educator with over 20 years of leadership and teaching experience. Holding an MBA in Global Economics, an EdS, and a PhD (abd) in Leadership, he is committed to youth mentorship, philanthropy, and expanding community access to life-changing resources.',
      image: person1
    },
    {
      id: 2,
      name: 'Executive Leadership',
      title: 'Community Outreach & Operations',
      description: 'Our dedicated leadership team brings decades of combined experience in violence intervention, youth advocacy, and social work to guide YLSN initiatives across Schenectady and Albany.',
      image: person2
    },
    {
      id: 3,
      name: 'Street Outreach Specialists',
      title: 'Crisis Mediation & Intervention Team',
      description: 'Our frontline street coordinators work directly within high-risk neighborhoods to mediate conflicts, de-escalate violence, provide pre-booking diversion, and support families in crisis 24/7.',
      image: person3
    }
  ];

  return (
    <section className="team-section">
      <div className="team-header">
        <span className="section-subtitle">OUR LEADERSHIP & FRONT-LINE TEAM</span>
        <h2 className="section-title">Dedicated Community Advocates</h2>
        <p className="section-description">
          Driven by passion, experience, and deep community roots, our team works tirelessly to save lives and support families.
        </p>
      </div>

      <div className="team-list">
        {myTeam.map((member) => (
          <div key={member.id} className="team-row-card">
            <div className="team-row-image">
              <img src={member.image} alt={member.name} />
            </div>

            <div className="team-row-info">
              <div className="team-role-chip">
                <i className="fa-solid fa-user-shield"></i>
                <span>{member.title}</span>
              </div>
              <h3 className="team-row-name">{member.name}</h3>
              <p className="team-row-bio">{member.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;